import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";

export const downloadFileCommentMulti = async ({
  documentName,
  commentID,
  sharepointToken,
}: {
  documentName?: string;
  commentID?: string;
  sharepointToken?: string;
}) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadFileCommentMulti,
    JSON.stringify({
      DocumentName: documentName,
      CommentID: commentID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const downloadFileRevisionMulti = async ({
  documentName,
  revisionID,
  sharepointToken,
}: {
  documentName?: string;
  revisionID?: string;
  sharepointToken?: string;
}) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadFileRevisionMulti,
    JSON.stringify({
      DocumentName: documentName,
      RevisionID: revisionID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};
